module.exports = "/_next/static/images/beadGrantServices-ff8ee00a7da34fc06275f64622821782.webp";